{
    "BANNER": {
        "TITLE": " Nationwide Access to Premium Healthcare",
        "DESCRIPTION": "Pay direct for routine care at the time of service, and less than what you would with insurance because of copays, deductibles, and coinsurances. Our packages are perfect as standalone protection, or as supplements to insurance plans.",
        "BANNER_SLIDES": [
            {
                "title": "Affordable Care, Exceptional Value",
                "subtitle": "A well-rounded healthcare solution from medical to dental and labs.",
                "buttonText": "View Plans",
                "link": "/join",
                "bannerClass": "jets-pizza-banner"
            },
        {
                "title": "Affordable Care, Exceptional Value",
                "subtitle": "A well-rounded healthcare solution from medical to dental and labs.",
                "buttonText": "View Plans",
                "link": "/join",
                "bannerClass": "jets-pizza-banner"
            },
            {
                "title": "Affordable Care, Exceptional Value",
                "subtitle": "A well-rounded healthcare solution from medical to dental and labs.",
                "buttonText": "View Plans",
                "link": "/join",
                "bannerClass": "jets-pizza-banner"
            }
        ]
    },
    "CLINICAL_BENEFITS": {
    "TITLE": "Experience the WoW Health Difference",
    "DESCRIPTION": "With your Aquoral purchase, you gain access to WoW Health's platform of healthcare solutions. Our membership plans are designed to provide you with comprehensive healthcare access and benefits, all without the need for insurance. Enjoy virtual urgent care, crisis tele-counseling, virtual primary care, discounted in-person visits for primary and urgent care, specialist consultations, up to 80% off medications, discounts on lab tests, imaging services, procedures and surgeries, and dental and vision benefits where available.",
    "BENEFITS_LIST": [
        {
            "title": "Nationwide Care",
            "description": "Virtual and In-person care, across a complete continuum with doctors, dentists, labs, pharmacies, and more!",
            "bgImage": "d-shape"
        },
        {
            "title": "Healthcare with a Concierge",
            "description": "Navigate the complexity of healthcare with a licensed Medic concierge to assist and address any concerns.",
            "bgImage": "circles"
        },
        {
            "title": "Personalized Care",
            "description": "Flexible membership options to fit your lifestyle and medical needs, with options to add family members.",
            "bgImage": "m-shape"
        }
    ]
     },
    "SERVICES": {
            "TITLE": "Comprehensive Healthcare Services",
            "DESCRIPTION": "Our platform offers a wide range of healthcare services to meet your needs. From virtual urgent care and tele-counseling to in-person primary care and specialist consultations, we have you covered. Our services are designed to provide you with convenient access to quality healthcare whenever you need it.",
            "PANES": [
                {
                    "heading": "Concierge-level Healthcare",
                    "active": false,
                    "buttonText": "Get Started",
                    "pointsList": [
                        {
                            "title": "Virtual Primary Care",
                            "description": "Appointment with the same doctor - no long waiting hours."
                        },
                        {
                            "title": "Virtual Urgent Care",
                            "description": "24/7 access to virtual care for non-emergency issues."
                        },
                        {
                            "title": "Tele counseling",
                            "description": "24/7 Mental health and personal life support with specialists."
                        },
                        {
                            "title": "Message-a-specialist",
                            "description": "Quick response on medical concerns via secure chat."
                        }
                    ]
                },
                {
                    "heading": "Dental Services",
                    "active": false,
                    "buttonText": "Get Started",
                    "pointsList": [
                        {
                            "title": "Dental Membership",
                            "description": "Access to dental care with discounted rates at participating providers."
                        },
                        {
                            "title": "Dental Concierge",
                            "description": "Assistance in finding dental providers, scheduling appointments, and addressing dental care concerns."
                        },
                        {
                            "title": "Dental Discounts",
                            "description": "Exclusive discounts on dental services, procedures, and products through our network of dental providers."
                        }
                    ]
                },
                {
                    "heading": "Exclusive Discount",
                    "active": false,
                    "buttonText": "Get Started",
                    "pointsList": [
                        {
                            "title": "Medication Savings",
                            "description": "Get up to 80% off on medications at participating pharmacies."
                        },
                        {
                            "title": "Lab and Imaging Discounts",
                            "description": "Save on lab tests, imaging services, procedures, and surgeries."
                        },
                        {
                            "title": "Specialist Consultations",
                            "description": "Access discounted rates for specialist consultations and in-person visits."
                        }
                    ]
                }
            ]
    },
    "MEMBERSHIP": {
        "MINI_TITLE": "Affordable Healthcare solution for you!",
        "TITLE": "Healthcare access with membership, no insurance needed",
        "DENTAL_VISION_LABEL": "Add Dental & Vision Benefits",
        "REDUCE_IN_PERSON_LABEL": " Reduce In-person Primary Care to $10 & Urgent Care to $25 ",
        "LABEL": "This plan includes:",
        "NOTE1": "**Comprehensive plan is not available to residents of WA",
        "NOTE2": "**HealthShare is not available in WA",
        "NOTE3": "**75% off for each additional family member",
        "MEMBERNOTES_LABEL": "Notes:",
        "MEMBERNOTES": " After 3 months, get one subsidized visit (50% reimbursement, up to $150). After 6 months, get a second subsidized visit. Can roll over 1 unused visit to the next year. ",
        "BTN_LABEL": "Get Started Now"
    },
    "TESTIMONIAL": {
        "MINI_TITLE": "Testimonials",
        "TITLE": "See how we've helped our members by hearing their stories."
    },
    "FAQS": {
        "MINI_TITLE": "How it works",
        "TITLE1": "Frequently",
        "TITLE2": "Asked Questions",
        "DESCRIPTION": "Need help? Reach out to our 24/7 customer support at  <a class='phone' href='tel:8449694325'>844-969-4325</a> and get the assistance you need.",
        "LINK": "Visit Faqs Page",
        "FAQ_LIST": [
            {
                "title": "Is WoW Health healthcare insurance?",
                "description": "No, WoW Health is not traditional health insurance. We're a portable membership plan that connects you with a network of healthcare providers at discounted rates. This means you can manage your health on your own terms, without being tied down to a specific employer plan."
            },
            {
                "title": "How can WoW Health accommodate my unpredictable work hours?",
                "description": "While we can't control your scheduling, WoW Health offers telemedicine options. With 24/7 access to doctors for minor injuries, illnesses, and prescriptions, you can receive care whenever it's most convenient for you. You can even get our services during your work breaks."
            },
            {
                "title": "Do I need to switch to WoW Health if I'm currently enrolled in another healthcare plan?",
                "description": "No, you don't need to switch. You can start your membership at WoW health at any time along with your health insurance or any other healthcare plan."
            },
            {
                "title": "How does WoW Health ensure transparent pricing?",
                "description": "We believe in upfront pricing to eliminate surprise bills and ensure transparency for our members. With WoW Health, you'll know exactly what you're paying for, allowing you to budget for your healthcare needs without any hidden costs or fees."
            },
            {
                "title": "If I get WoW Health, will I lose my government subsidy for a health plan?",
                "description": "No, since WoW Health is a membership and NOT an insurance plan, if you qualify for any government subsidy, you can continue to qualify for one. WoW Health can be a great supplement in this case for better routine care access."
            },
            {
                "title": "What kind of medications are included in the Plus and Comprehensive memberships with free medications?",
                "description": "WoW Health provides up to 400 generic medications at no cost to alleviate the financial burden of managing health conditions. These medications cover a wide range of common healthcare needs."
            },
            {
                "title": "Are mental health services available for coping with stress?",
                "description": "Absolutely, WoW Health provides free counseling sessions to address stress and burnout common in today's work environment, helping you manage your mental health effectively."
            },
            {
                "title": "What if I have questions or need assistance with my WoW Health plan?",
                "description": "Our dedicated customer support team is here to help you every step of the way. Whether you have questions about your coverage, need assistance with booking appointments, or require support with accessing our telemedicine services, our team is just a phone call or message away at 844-969-4325."
            }
         ]
    }
}